export enum LocationMatchType {
    LIKE = 'like',
    NOT_LIKE = 'not like',
    REGEX = 'regex',
    NOT_REGEX = 'not regex',
    EQUAL = 'equal',
}
